import { useSyncExternalStore } from 'react'

/* Whether a leg-page table fits the viewport, or the phone shape is drawn
 * instead (frontend/README.md: a narrow screen changes the pattern, it never
 * scrolls an editable grid sideways). `md`, 48rem.
 *
 * Read during render through `useSyncExternalStore`, like `Sheet`'s breakpoint,
 * so the first paint already has the right shape and ONE shape is mounted — a
 * row's controls are never drawn twice. The server-render fallback is the
 * phone. Shared by the unit cards and «Оплаты перевозчику» (S-12, S-10); a
 * test of either phone shape mocks `window.matchMedia`. */
const TABLE_QUERY = '(min-width: 48rem)'

function subscribe(onChange: () => void) {
  const query = window.matchMedia(TABLE_QUERY)
  query.addEventListener('change', onChange)
  return () => query.removeEventListener('change', onChange)
}

export function useTableFits(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(TABLE_QUERY).matches,
    () => false,
  )
}
